<label *ngIf="examEvent" class="w-100">
    <input
      type="radio"
      class="visually-hidden"
      [formControl]="control"
      [value]="examEvent.id"
      [name]="name"
      [id]="'timeSlot' + examEvent.id"
      (change)="control.setValue(examEvent.id)"
      [checked]="checked"
    />
  <div
    class="card test-time-card p-3 d-flex flex-column justify-content-center align-items-center test text-center"
    [class.border-secondary]="checked"
    [class.bg-light]="checked"
    [class.selected]="checked"
  >
    <p class="mb-1">
      {{
        'booking.default.details.timeFormat.dayOfWeek'
          | translate
            : {
                timeSlot: timeSlot | localizedDate: 'EEEE'
              }
      }}
      <strong>{{
        'booking.default.details.timeFormat.date'
          | translate
            : {
                timeSlot:
                  timeSlot | localizedDate: 'mediumDate'
              }
      }}</strong>
    </p>
    <p *ngIf="!isProctoring">
      {{
        'booking.default.details.timeFormat.area'
          | translate: { testarea: examEvent.testarea }
      }}
    </p>
    <p *ngIf="isProctoring">
      {{
        'booking.default.details.timeFormat.proctoring'
          | translate: { testarea: examEvent.testarea }
      }}
    </p>

    <span class="fs-4 fw-bold mb-3">{{
      'booking.default.details.timeFormat.time'
        | translate
          : {
              timeSlot:
                timeSlot | localizedDate: 'shortTime'
            }
    }}</span>
    <p>
      {{
        'booking.default.details.timeFormat.registrationPeriodEnd'
          | translate
      }}:
      <br />
      {{
        examEvent.registerTimeTo
          | localizedDate: 'dd.MM.yyyy'
      }},
      {{
        'booking.default.details.timeFormat.time'
          | translate
            : {
                timeSlot:
                  examEvent.registerTimeTo
                  | localizedDate: 'shortTime'
              }
      }}
    </p>
    <p *ngIf="isPriceVisible">
      {{ 'label.test-event-price' | translate }}:
      {{
        examEvent.price.amount
          | currency
            : examEvent.price.currency
            : undefined
            : undefined
            : currentLanguage
      }}
    </p>
  </div>
</label>
